export default __webpack_public_path__ + "static/media/avatar.fd34b168.svg";